module.exports = __webpack_public_path__ + "img/81.6.CODm.62dd1bd8.png";